const PROVIDER_DISPLAY_NAMES = {
  evoplay: "Evoplay",
  bgaming: "BGaming",
  tadagaming: "Tada Game",
  tada: "Tada Game",
  evolution: "Evolution",
  pragmatic: "Pragmatic Play",
  kagaming: "KA Gaming",
  kaga: "KA Gaming",
  upgaming: "Up Gaming",
  hacksaw: "Hacksaw Gaming",
  gamingcorps: "Gaming Corps",
  pixmove: "Pix Move",
};

export const getProviderDisplayName = code => PROVIDER_DISPLAY_NAMES[code?.toLowerCase()] ?? code;
